export default "__VITE_ASSET__B5lzE9gp__ 224w, __VITE_ASSET__CsrY1mrM__ 448w";